export const FacebookIconSmall = () => {
    return (
        <svg
            width="22"
            height="23"
            viewBox="0 0 22 23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M11 21.5616C16.799 21.5616 21.5 16.8606 21.5 11.0616C21.5 5.26259 16.799 0.561584 11 0.561584C5.20101 0.561584 0.5 5.26259 0.5 11.0616C0.5 16.8606 5.20101 21.5616 11 21.5616Z"
                fill="#2E2E2E"
                stroke="white"
            />
            <path
                d="M15.8659 5.59332H6.13409C5.97434 5.59332 5.82112 5.65678 5.70816 5.76974C5.5952 5.88271 5.53174 6.03592 5.53174 6.19568V15.9274C5.53174 16.0872 5.5952 16.2404 5.70816 16.3534C5.82112 16.4663 5.97434 16.5298 6.13409 16.5298H11.3741V12.2945H9.94115V10.6474H11.367V9.42861C11.367 8.01685 12.2282 7.24744 13.4847 7.24744C13.9099 7.24549 14.3349 7.26749 14.7576 7.31332V8.78861H13.8847C13.1976 8.78861 13.0659 9.11568 13.0659 9.59332V10.6474H14.7011L14.487 12.2945H13.0753V16.5298H15.8635C16.0233 16.5298 16.1765 16.4663 16.2894 16.3534C16.4024 16.2404 16.4659 16.0872 16.4659 15.9274V6.19568C16.4659 6.03633 16.4027 5.88347 16.2903 5.77058C16.1778 5.65768 16.0252 5.59395 15.8659 5.59332Z"
                fill="white"
            />
        </svg>
    );
};
